import { createElementBlock as t, openBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
};
function l(a, e) {
  return n(), t("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M10.667 4A6.667 6.667 0 0 0 4 10.667v10.666A6.667 6.667 0 0 0 10.667 28h10.666A6.667 6.667 0 0 0 28 21.333V10.667A6.667 6.667 0 0 0 21.333 4zM24 6.667a1.334 1.334 0 1 1-.001 2.667A1.334 1.334 0 0 1 24 6.667m-8 2.666a6.667 6.667 0 1 1-.002 13.335A6.667 6.667 0 0 1 16 9.333M16 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
    }, null, -1)
  ])]);
}
const c = { render: l };
export {
  c as default,
  l as render
};
